import { useState } from "react";
import { Utils } from "../../common/views/Utils";
import { UploadPictureModel } from "../../pictures/models/PictureModel";
import { AdminGroupService } from "../services/AdminGroupService";

export default function useNewOneTimeProductVM() {
    const groupService = new AdminGroupService();

    const [pictures, setPictures] = useState<UploadPictureModel[]>([]);
    const [listHash, setListHash] = useState<number>(Utils.getRandomKey());
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const updatePictureField = <K extends keyof UploadPictureModel>(
        id: number, field: K, value: UploadPictureModel[K]
    ) => {
        setPictures(prev =>
            prev.map(item => item.id === id ? { ...item, [field]: value } : item)
        );
    };

    const submit = (): JQueryPromise<any> => {
        const formData = buildFormData("files");
        return Utils.postFormData(formData, groupService.RoutePostCreateOneTime());
    }

    const buildFormData = (prefix: string): FormData => {
        var requestForm = new FormData();

        for (let i = 0; i < pictures.length; i++) {
            const picture = pictures[i];
            const prefixIndex = prefix + "[" + i + "]";
            Utils.buildFormDataProperties(requestForm, picture, [], prefixIndex);
        }

        return requestForm;
    }

    return {
        pictures, setPictures,
        listHash, setListHash,
        loading, setLoading,
        submitting, setSubmitting,

        updatePictureField,
        submit
    }
}